import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import UserContext from '../UserContext';
import { Alert, Chip, Link } from '@mui/material';
import { SectionTitle } from '../components/StyledComponent';
import ConnectedIcon from '@mui/icons-material/Done';
import RefreshIcon from '@mui/icons-material/Refresh';
import AuthRequiredIcon from '@mui/icons-material/LinkOff';
import styles from '../style/common.module.css';
import AppConfig from '../AppConfig';
import { hasFeature } from '../business/Subscription';
import { isXpmConnected } from '../rest/BackendApi';
import MessageContext, { error } from '../MessageContext';
import { LoadingSpinner } from '../components/Loading';
export default function XpmPage() {
    const userContext = useContext(UserContext);
    const messageContext = useContext(MessageContext);
    const user = userContext === null || userContext === void 0 ? void 0 : userContext.user;
    const [xpmStatus, setXpmStatus] = useState({ connected: false, authenticationSuccessful: false, allScopes: false });
    const [loading, setLoading] = useState(false);
    if (!hasFeature(user, 'XPM')) {
        return _jsx("div", { children: "Xpm not available in your subscription" });
    }
    useEffect(() => {
        setLoading(true);
        isXpmConnected(true)
            .then(xpmConnected => setXpmStatus(xpmConnected))
            .catch((exception) => messageContext.setMessage(error('Failed to check xpm connection')))
            .finally(() => setLoading(false));
    }, [user]);
    const XpmConnectionStatus = () => {
        if (loading) {
            return _jsx(LoadingSpinner, {});
        }
        else if (xpmStatus.connected) {
            if (xpmStatus.authenticationSuccessful && xpmStatus.allScopes) {
                return _jsxs(_Fragment, { children: [_jsx(ConnectedIcon, { color: "success" }), "Connected", _jsx(RefreshIcon, { sx: { marginLeft: 2 }, color: "info" }), _jsx(Link, { href: AppConfig.oauthXpmPath, children: "Refresh connection with xpm" })] });
            }
            else {
                return _jsxs(_Fragment, { children: [_jsx(AuthRequiredIcon, { color: "warning" }), "Connected but requires (re)authentication", _jsx(Link, { href: AppConfig.oauthXpmPath, children: "Refresh connection with xpm" })] });
            }
        }
        else {
            return _jsxs(_Fragment, { children: [_jsx(AuthRequiredIcon, { color: "error" }), "Not connected", _jsx(Link, { href: AppConfig.oauthXpmPath, children: "Connect xpm" })] });
        }
    };
    return (user && (_jsxs("div", { style: { padding: '10px' }, children: [_jsxs(SectionTitle, { children: ["XPM (Xero Practice Manager) ", _jsx(Chip, { size: "small", label: "BETA", color: "info" })] }), _jsxs(Alert, { severity: "info", sx: { mb: 2 }, children: ["You can now link XPM to your firm.", _jsx("br", {}), "It will match xero organisation based on ABN.", _jsx("br", {}), _jsx("br", {}), "Once you have connected XPM, there will be a column in the dashboard with a link to the XPM Job."] }), _jsxs("div", { style: { gap: 8, paddingTop: 8 }, className: styles.left, children: [_jsx("span", { children: "Xero Practice Manager:" }), _jsx(XpmConnectionStatus, {})] })] })));
}
;
